var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9751 43.1973H22.358C20.7294 43.1973 19.4094 44.5173 19.4094 46.1459C19.4094 46.763 19.9066 47.2601 20.5237 47.2601H39.8094C40.4266 47.2601 40.9237 46.763 40.9237 46.1459C40.9237 44.5173 39.6037 43.1973 37.9751 43.1973Z",
    fill: "#183028"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1223 42.044H23.1723C23.3909 42.044 23.5752 41.8768 23.5966 41.6582L24.6809 30.3997C24.8223 28.9254 25.5938 27.5582 26.8366 26.7568C26.8538 26.7482 26.8666 26.7354 26.8838 26.7269C27.2952 26.4654 27.7366 26.9969 27.4281 27.3697C26.8495 28.0683 26.2881 29.0325 26.1852 30.2154C25.9623 32.774 25.5681 39.7597 25.4652 41.594C25.4523 41.8383 25.6452 42.0397 25.8938 42.0397H38.2152C38.4681 42.0397 38.6652 41.8211 38.6395 41.5725L37.4695 29.5468C37.2295 26.7525 34.8895 24.6055 32.0866 24.6055H28.2938C25.4952 24.6055 23.1595 26.744 22.9109 29.5298L21.6981 41.5725C21.6723 41.8254 21.8695 42.044 22.1223 42.044Z",
    fill: "#E87722"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1665 12.7422V21.2537",
    stroke: "#183028",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6238 18.3516L22.6452 24.3687",
    stroke: "#183028",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7097 18.3516L37.6882 24.3687",
    stroke: "#183028",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0181 31.8906H19.5295",
    stroke: "#183028",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8037 31.8906H49.3151",
    stroke: "#183028",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.3a10fc87869ec6dbe6f383735d7be3d8.svg";
export { ForwardRef as ReactComponent };